import { render, staticRenderFns } from "./PUCText.vue?vue&type=template&id=5106982c&scoped=true&"
import script from "./PUCText.vue?vue&type=script&lang=js&"
export * from "./PUCText.vue?vue&type=script&lang=js&"
import style0 from "./PUCText.vue?vue&type=style&index=0&id=5106982c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5106982c",
  null
  
)

export default component.exports